<div
  class="
    d-flex
    flex-column flex-column-fluid
    bgi-position-y-bottom
    position-x-center
    bgi-no-repeat bgi-size-contain bgi-attachment-fixed
  "
>
  <div class="d-flex flex-column flex-column-fluid text-center p-10 py-lg-20 justify-content-center">
    <a (click)="routeToDashboard()" class="mb-10 pt-lg-20 cursor-pointer">
      <app-logo [classes]="'h-150px mb-5'"></app-logo>
    </a>
    <div class="pt-lg-10">
      <router-outlet></router-outlet>

      <div class="text-center">
        <a
          (click)="routeToDashboard()"
          class="btn btn-lg btn-primary fw-bolder cursor-pointer"
        >
          <span>{{"errors.torna-dashboard" | translate}}</span>
        </a>
      </div>
    </div>
  </div>

  <!-- begin::Footer -->
  <div class="d-flex flex-center flex-column-auto p-10">
    <div class="d-flex align-items-center fw-bold fs-6">
      <a *ngIf="translate.currentLang === 'it'" class="text-muted text-hover-primary px-2 cursor-pointer"
        href="https://istitutomedicolegale.it/" target="_blank">istitutomedicolegale.it</a>
      <a *ngIf="translate.currentLang === 'es'" class="text-muted text-hover-primary px-2 cursor-pointer"
         href="https://solucionmedicolegal.es/" target="_blank">solucionmedicolegal.es</a>
    </div>
  </div>
  <!-- end::Footer -->
</div>
